import type { InjectionKey } from 'vue'
import { type AppConfig } from './app_config_provider'; 

export interface InitContext {
  netz_id: number|null,
  netz: string|null,
  order_reference: string|null,
  order_import: string|null,
  checker_result_uid: string|null,
  pv_ids: number[],
}

const defaultContext: InitContext = {
  netz_id: null,
  netz: null,
  order_reference: null,
  order_import: null,
  checker_result_uid: null,
  pv_ids: []
}



export const initContextKey: InjectionKey<InitContext> = Symbol('init-context')


export function loadInitContext(config:AppConfig): InitContext {
  let context = defaultContext;
  // Netz
  const urlNetzId = extractAndRemoveParam("netz_id", "^[0-9]+$");
  if (null != urlNetzId){
    context.netz_id = toInt(urlNetzId);
  }
  const urlNetz = extractAndRemoveParam("netz", "^[a-zA-Z0-9_-]+$");
  if (null != urlNetz){
    context.netz = urlNetz;
  }

  const urlCheckerResultUid = extractAndRemoveParam("checker_result_uid", "^[a-zA-Z0-9_-]+$"); 
  if (null != urlCheckerResultUid) {
    context.checker_result_uid = urlCheckerResultUid;
  }

  // Order Import
  context.order_import = extractAndRemoveParam("order_import", "^[0-9a-zA-Z]+$")

  // Product Variant Ids
  const pvIds = extractAndRemoveParam("pv_ids", "^[0-9,]+$");
  if (null != pvIds && pvIds.trim() != ""){
    const parts = pvIds.split(",");
    let ids: number[] = [];
    parts.forEach(function(p){
      const id = toInt(p);
      if (id !== null){
        ids.push(id)
      }
    })
    context.pv_ids = ids;
  }

  // order_refrence from Cookie
  context.order_reference = readCookieIfValid(config.cookie_name, "^[0-9a-zA-Z]+$");

  return context;
}

function extractAndRemoveParam(
  key: string,
  regexPattern: string
): string|null {
  // Build regex safely from string
  const pattern = new RegExp(regexPattern);

  // Parse current URL
  const url = new URL(window.location.href);
  const value = url.searchParams.get(key);

  if (!value) {
    return null;
  }

  // Validate against regex
  if (!pattern.test(value)) {
    return null
  }

  // Remove the parameter
  url.searchParams.delete(key);

  // Update the browser URL without reloading
  window.history.replaceState({}, "", url.toString());

  return value;
}

export function readCookieIfValid(
  cookieName: string,
  regexPattern: string
): string|null {
  const pattern = new RegExp(regexPattern);

  // Read cookie
  const cookies = document.cookie.split(";").map(c => c.trim());

  const entry = cookies.find(c => c.startsWith(cookieName + "="));
  if (!entry) {
    return null
  }

  const value = entry.substring(cookieName.length + 1);

  // Validate
  if (!pattern.test(value)) {
    return null
  }

  return value;
}


function toInt(value: string): number | null {
  const parsed = Number.parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
}

